<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.program.edit')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">

                    <form role="form" @submit.prevent="isClone ?saveProgram(): updateProgram()">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.program.edit')}}</div>
                            <button v-if="isClone" class="btn btn-primary float-right"
                                :disabled="disableEditForm || readonly">{{$t('button.save')}}</button>


                            <div v-else  class="text-right">
                                <button class="btn btn-primary"
                                    :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                                <button class="btn btn-info" @click="shouldClose = true"
                                    :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                                <div class="btn-group">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{$t('button.programCoursesReport')}}
                                    </button>
                                    <div class="dropdown-menu">
                                        <button class="dropdown-item" type="button" @click="exportProgramCourses('pdf')"><i class="fas fa-file-pdf"></i> {{$t('button.pdf')}}</button>
                                        <button class="dropdown-item" type="button" @click="exportProgramCourses('word')"><i class="fas fa-file-word"></i> {{$t('button.word')}}</button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="card-body">

                            <b-tabs content-class="mt-3">
                                <b-tab :title="$t('form.program.tabGeneral')" active>

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label for="ProgramCode:">
                                                    {{$t('form.program.programCode')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div>
                                                    <v-select :options="programCodes"
                                                        v-model.trim="$v.program.ProgramCode.$model"
                                                        :reduce="programCodes => programCodes"
                                                        :key="program.ProgramCode"
                                                        :class="{ 'is-invalid': $v.program.ProgramCode.$error }">
                                                    </v-select>
                                                    <div class="invalid-feedback custom-validate"
                                                        v-if="invalidProgramCode">
                                                        {{$t('form.validation.required')}}</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="ProgramType:">
                                                    {{$t('form.program.programType')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div>
                                                    <v-select :options="programTypes"
                                                        v-model.trim="$v.program.ProgramType.$model"
                                                        :reduce="programTypes => programTypes">
                                                    </v-select>
                                                    <div class="invalid-feedback"
                                                        v-if="!$v.program.ProgramType.required">
                                                        {{$t('form.validation.required')}}</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="ProgramTitle:">
                                                    {{$t('form.program.programTitle')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div>
                                                    <input type="text" id="ProgramTitle:" class="form-control"
                                                        v-model.trim="$v.program.ProgramTitle.$model"
                                                        :class="{ 'is-invalid': $v.program.ProgramTitle.$error }">
                                                    <div class="invalid-feedback"
                                                        v-if="!$v.program.ProgramTitle.required">
                                                        {{$t('form.validation.required')}}</div>
                                                </div>
                                            </div>


                                            <div class="form-group">
                                                <label>{{$t('form.program.transcriptTitle')}}</label>
                                                <v-select :options="programTranscriptTitles" v-model.trim="program.TranscriptTitle">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.program.specialization')}}</label>
                                                <v-select :options="programSpecializations" v-model.trim="program.Specialization">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.program.major')}}</label>
                                                <v-select :options="programMajors" v-model.trim="program.Major">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label for="AcademicYear:">
                                                    {{$t('form.program.academicYear')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div>
                                                    <select v-model.trim="$v.program.AcademicYear.$model"
                                                        class="form-control"
                                                        :class="{ 'is-invalid': $v.program.AcademicYear.$error }">
                                                        <option v-for="(year , index) in programYears" :key="index"
                                                            :value="year">{{year}}</option>
                                                    </select>
                                                    <div class="invalid-feedback"
                                                        v-if="!$v.program.AcademicYear.required">
                                                        {{$t('form.validation.required')}}</div>
                                                </div>
                                            </div>

                                            <div class="form-group" v-if="showFoundationProgram">
                                                <label class for="FoundationID">
                                                    {{ $t("form.program.foundationProgram") }}
                                                </label>
                                                <div class>
                                                    <v-select
                                                        :get-option-label="p => `${p.ProgramTitle}, ${p.ProgramCode}, ${p.ProgramType}, ${new Date(p.AcademicYear).getFullYear()}`"
                                                        :options="foundationProgramList"
                                                        :disabled="readonly"
                                                        v-model="program.FoundationID"
                                                        :reduce="program => program.ID"
                                                    >
                                                    </v-select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="Notes:">{{$t('form.program.notes')}}</label>
                                                <div>
                                                    <textarea id="Notes:" rows="5" class="form-control k-textbox"
                                                        v-model="program.Notes" data-role="textarea"
                                                        data-parsley-errors-container="#errId5"></textarea>
                                                    <span id="errId5" class="error"></span>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.program.gradingScaleType')}}</label>
                                                <v-select label="name" :reduce="t => Number(t.id)" :options="gradingScaleTypes" v-model="program.GradingScaleTypeID"></v-select>
                                                <small class="form-text text-muted">{{$t('form.program.gradingScaleTypeHint')}}</small>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.student.partnerCode')}}</label>
                                                <v-select label="PartnerCode" :options="partners"
                                                    v-model="program.PartnerCode"
                                                    :reduce="partners => partners.PartnerCode" multiple>
                                                </v-select>
                                            </div>

                                            <hr>

                                            <div class="form-group">
                                                <label>{{$t('form.program.billingCycle')}}</label>
                                                <b-form-select v-model="program.BillingCycle" :options="billingCycles">
                                                </b-form-select>
                                                <small v-if="program.BillingCycle == 'inherit'" class="form-text text-muted">{{$t('form.program.paymentPlanRequiredBillingCycle')}}</small>
                                            </div>

                                            <div class="form-group  d-flex justify-content-between">
                                                <label>{{$t('form.program.issueInvoices')}}</label>
                                                <input v-model="program.days" type="number" min=1 max=60 class="form-control col-xs-2">
                                                <label class="mt-2">{{$t('form.program.days')}}</label>
                                           
                                                <b-form-select v-model="program.beforeOrAfter" :options="afterOrBeforeDropdown" class="col-xs-2"></b-form-select>
                                                <label>{{$t('form.program.cycleStartDate')}}</label>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.program.applicationFee')}}</label>
                                                <b-form-input v-model="program.ApplicationFee"></b-form-input>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.program.acceptanceFee')}}</label>
                                                <b-form-input v-model="program.AcceptanceFee"></b-form-input>
                                            </div>

                                            <hr>

                                            <template v-if="program.BillingCycle=='term'">
                                                <div v-for="(semester, index) in semesters"
                                                :key="index">
                                                <div class="row">
                                                    <label>{{$t('form.program.semTerm')}} {{semester}}</label>
                                                </div>
                                                <form>
                                                <div class="form-row">
                                                    <div class="form-group col-md-4">
                                                    <label :for="'semesterFee'.semester">{{$t('form.program.fee')}}</label>
                                                    <b-form-input v-model="program.TermFee[semester - 1]" :id="'semesterFee'.semester">
                                                    </b-form-input>
                                                </div>
                                                    <div class="form-group col-md-4">
                                                    <label :for="'semesterFrom'.semester">{{$t('form.program.fromSemDate')}}</label>
                                                    <date-picker :lang="lang" class="date-picker"
                                                        v-if="index == semesters.length-1"
                                                        v-model="semesterDates.semesterFrom[semester-1]"
                                                        valueType="format" :format="dateFormat"
                                                        :append-to-body="false"
                                                        >
                                                    </date-picker>
                                                    <date-picker :lang="lang" class="date-picker"
                                                        v-else
                                                        v-model="semesterDates.semesterFrom[semester-1]"
                                                        valueType="format" :format="dateFormat"
                                                        :popup-style="{ top: '100%'}"
                                                        :append-to-body="false"
                                                        >
                                                    </date-picker>
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                    <label :for="'semesterTo'.semester">{{$t('form.program.toSemDate')}}</label>
                                                    <date-picker :lang="lang" class="date-picker"
                                                        v-if="index == semesters.length-1"
                                                        v-model="semesterDates.semesterTo[semester-1]"
                                                        valueType="format" :format="dateFormat"
                                                        :append-to-body="false"
                                                        >
                                                    </date-picker>
                                                    <date-picker :lang="lang" class="date-picker"
                                                            v-else
                                                            v-model="semesterDates.semesterTo[semester-1]"
                                                            valueType="format" :format="dateFormat"
                                                            :popup-style="{ top: '100%'}"
                                                            :append-to-body="false"
                                                            >
                                                    </date-picker>
                                                    </div>
                                                </div>
                                                </form></div>
                                                </template>

                                            <div class="d-flex justify-content-between">
                                                <label>{{$t('form.program.totalCost')}}</label>
                                                <p>{{totalFee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-sm-8">
                                            <div class="form-group" v-if="!readonly">
                                                <label for="Courses">{{$t('form.program.courses')}}</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control"
                                                        :placeholder="$t('form.program.searchCourse')"
                                                        v-model="courseTitle" @click="filterCourses" autocomplete="off">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text remove_btn" @click="clear()">
                                                            <i class="fa fa-times"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul class="list-group m-0">
                                                    <li class="list-group-item" v-for="(result,index) in courses"
                                                        v-bind:key="index">
                                                        <a style="cursor:pointer"
                                                            @click="addCourse(result)">{{ result.FullTitle}}</a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="form-group">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>{{$t('form.program.course')}}</th>
                                                                <th>{{$t('form.program.sem')}}</th>
                                                                <th>{{$t('form.program.programYear')}}</th>
                                                                <th>{{$t('form.program.fromCourse')}}</th>
                                                                <th>{{$t('form.program.toCourse')}}</th>
                                                                <th v-if="program.BillingCycle=='course'">
                                                                    {{$t('form.program.fee')}}</th>
                                                                    <th v-if="program.BillingCycle=='course'">
                                                                        {{$t('form.program.invoicedSeparately')}}</th>
                                                                <th class="text-right" v-if="!readonly">
                                                                    {{$t('form.program.action')}}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(course, index) in $v.programCourses.$each.$iter"
                                                                :key="index">
                                                                <td>{{course.$model.CourseCode}} -
                                                                    {{course.$model.CourseTitle}}</td>
                                                                <td>
                                                                    <input type="number"
                                                                        v-model="course.$model.Semester"
                                                                        class="form-control" @change="fetchSemesters()">
                                                                </td>
                                                                <td style="width: 100px;">
                                                                    <input type="number"
                                                                        v-model="course.ProgramYear.$model"
                                                                        class="form-control"
                                                                        :class="{ 'is-invalid': course.ProgramYear.$error }">
                                                                    <div class="invalid-feedback"
                                                                        v-if="!course.ProgramYear.between">
                                                                        {{$t('form.validation.between', {num1: course.ProgramYear.$params.between.min, num2: course.ProgramYear.$params.between.max})}}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <date-picker class="date-picker" 
                                                                    :lang="lang"
                                                                    v-if="index == programCourses.length-1 ||
                                                                    index == programCourses.length-2 ||
                                                                    index == programCourses.length-3 ||
                                                                    index == programCourses.length-4"
                                                                        v-model="course.$model.CourseFrom"
                                                                        valueType="format" :format="dateFormat"
                                                                        :append-to-body="false">
                                                                    </date-picker>
                                                                    <date-picker class="date-picker" 
                                                                        v-else
                                                                        :lang="lang"
                                                                        v-model="course.$model.CourseFrom"
                                                                        valueType="format" :format="dateFormat"
                                                                        :popup-style="{ top: '100%'}"
                                                                        :append-to-body="false">
                                                                    </date-picker>
                                                                </td>
                                                                <td>
                                                                    <date-picker class="date-picker"
                                                                    :lang="lang"
                                                                    v-if="index == programCourses.length-1 ||
                                                                    index == programCourses.length-2 ||
                                                                    index == programCourses.length-3 ||
                                                                    index == programCourses.length-4"
                                                                        v-model="course.$model.CourseTo"
                                                                        valueType="format" :format="dateFormat"
                                                                        :append-to-body="false">
                                                                    </date-picker>
                                                                    <date-picker class="date-picker"
                                                                        v-else
                                                                        :lang="lang"
                                                                        v-model="course.$model.CourseTo"
                                                                        valueType="format" :format="dateFormat"
                                                                        :popup-style="{ top: '100%'}"
                                                                        :append-to-body="false">
                                                                    </date-picker>
                                                                </td>
                                                                <td v-if="program.BillingCycle=='course'">
                                                                    <input type="number" v-model="course.$model.Fee"
                                                                        class="form-control">
                                                                </td>
                                                                <td class="text-right" v-if="!readonly && program.BillingCycle=='course'">
                                                                   <span>
                                                                        <input type="checkbox" v-model="course.$model.InvoicedSeparately" :value="1" true-value="1" false-value="0">
                                                                   </span> 
                                                                </td><td>
                                                                    <a class="btn btn-danger text-white btn-sm"
                                                                        @click="removeCourse(index)">
                                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.program.tabAudit')">
                                    <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                        :sort-desc="true" :current-page="currentPage" :fields="fields" small hover
                                        bordered responsive>
                                    </b-table>

                                    <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                        :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                    </b-pagination>
                                </b-tab>
                            </b-tabs>

                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        alpha,
        between
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'datetimeFormat', 'applicationFee', 'dateFormat', 'decimalDigits',
            'decimalPoint', 'thousandSeparator'
        ],

        data() {
            return {
                form: {
                    FoundationID: null
                },
                showFoundationProgram: false,
                foundationProgramList: [],
                foundationAllowedCodes: [],
                shouldClose:false,
                isClone:false,
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                invalidProgramCode: false,
                invalidProgramType: false,
                interval: '',
                disableEditForm: false,
                disableEditFormMessage: '',
                closing: true,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                semesterDates:{
                   semesterFrom:[],
                   semesterTo:[] 
                },

                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                gradingScaleTypes: [],
                program: {
                    ProgramTitle: null,
                    TranscriptTitle: null,
                    ProgramCode: null,
                    ProgramType: null,
                    AcademicYear: null,
                    Specialization: null,
                    Major: null,
                    Notes: null,
                    GradingScaleTypeID: null,
                    BillingCycle:'inherit',
                    beforeOrAfter:'before',
                    ApplicationFee: this.defaultApplicationFee,
                    AcceptanceFee: null,
                    TermFee: [],
                    PartnerCode: [],
                    days:null,
                    TS: null
                },

                billingCycles: [{
                        text: this.$t('form.program.defaultProgramTypeBillingCycle'),
                        value: 'inherit'
                    },
                    {
                        text: this.$t('form.program.byCourse'),
                        value: 'course'
                    },
                    {
                        text: this.$t('form.program.byTerm'),
                        value: 'term'
                    },
                ],
                afterOrBeforeDropdown:[{
                text: this.$t('form.program.before'),
                        value: 'before'
                },{
                text: this.$t('form.program.after'),
                        value: 'after'
                }],

                programCodes: [],
                programSpecializations: [],
                programTranscriptTitles:[],
                programMajors: [],
                programTypes: [],
                programYears: [],
                programCourses: [],
                audits: [],
                partners: [],

                courses: [],
                courseTitle: '',
                semesters: [],
            }
        },
        validations: {
            program: {
                ProgramCode: {
                    required
                },
                ProgramType: {
                    required
                },
                ProgramTitle: {
                    required,
                    maxLength: maxLength(100)
                },
                AcademicYear: {
                    required
                }
            },
            programCourses: {
                $each: {
                    ProgramYear: {
                        between: between(1, 10)
                    }
                }
            }
        },

        mounted() {

            if (!this.permissions.viewPrograms) {
                this.$router.push("/");
                return;
            }


            if (this.permissions.editPrograms) {
                this.checkForEdit();
                let self = this;
                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.isClone = this.$route.params.clone;

            this.initialData();
            this.getProgramById();
            this.getAudits();
        },

        computed: {
            defaultApplicationFee() {
                return this.applicationFee; // fetch from config later
            },

            totalAudits() {
                return this.audits.length
            },

            totalFee() {
                let total = 0;
                let acceptance_fee = parseFloat(this.program.AcceptanceFee);

                // Semesters/Terms Sum
                if (this.program.BillingCycle == 'term') {
                    total = this.program.TermFee.reduce((a, b) => {
                        if (b) return parseFloat(a) + parseFloat(b)

                        return parseFloat(a)
                    }, 0);
                }

                // Courses Sum
                else if (this.program.BillingCycle == 'course') {
                    total = this.programCourses.reduce((a, b) => {
                        if (b.Fee) return parseFloat(a) + parseFloat(b.Fee)

                        return parseFloat(a)
                    }, 0);
                }


                // Administration Fee Add
                if (acceptance_fee) total += acceptance_fee;

                return total.toFixed(2);
            },

            readonly() {
                return !this.permissions.editPrograms;
            }
        },

        watch: {
            'program.ProgramCode'(newCode) {
                this.showFoundationProgram = this.foundationAllowedCodes.includes(newCode);
                if (this.showFoundationProgram) {
                    this.loadPrograms();
                }
            },

            foundationAllowedCodes(codes) {
                if (this.program.ProgramCode && codes?.length) {
                this.showFoundationProgram = codes.includes(this.program.ProgramCode);
                if (this.showFoundationProgram) {
                    this.loadPrograms();
                }
                }
            },

            courseTitle(value) {
                if (value == '') {
                    this.courses = [];
                    return;
                };

                this.filterCourses();
            },

            program: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            programCourses: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            loadPrograms() {
                axios.get('/api/programs?full=1')
                    .then(res => {
                        this.foundationProgramList = res.data;
                    });
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {
                    type
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },
            /*
                Export Program Courses
            */
             async exportProgramCourses(type) {
                let token = await this.createToken('student-grades');

                if (token == '') return;

                let url = `/transcripts/program-course/${this.program.ID}/${type}?token=${token}`;
                // if (this.invoiceType) url += `&type=${this.invoiceType}`;

                window.open(url, '_blank');
            },

            fetchSemesters() {
                let semesters = [];

                this.programCourses.forEach(c => {
                    let s = parseInt(c.Semester);
                    if (s) semesters.push(s);
                });

                this.semesters = [...new Set(semesters)].sort();
            },

            initialData() {
                axios
                    .get('/api/programs/initial-data')
                    .then(({
                        data
                    }) => {
                        this.programCodes = data.program_codes;
                        this.programTypes = data.program_types;
                        this.programYears = data.program_years;
                        this.programSpecializations  =data.program_specializations;
                        this.programTranscriptTitles  =data.program_transcript_titles;

                        this.gradingScaleTypes = data.grading_scale_types;

                        this.programMajors  = data.program_majors;
                        this.partners = data.partners;

                        this.perPageAudits = data.auditsPaginate;

                        this.foundationAllowedCodes = data.foundation_program_codes;
                        this.foundationProgramList = data.foundation_programs;

                        if (this.program.ProgramCode && this.foundationAllowedCodes.includes(this.program.ProgramCode)) {
                            this.showFoundationProgram = true;
                            this.loadPrograms();
                        }
                    })
                    .catch(error => console.log('error fetching initial data'));
            },

            filterCourses() {

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();

                this.request_source = source;

                axios
                    .get("/api/courses/", {
                        params: {
                            codeOrTitle: this.courseTitle
                        },
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.courses = response.data.data.data;
                        this.courses.map(course => {
                            course.FullTitle = `${course.ID} - ${course.CourseCode} - ${course.CourseTitle} - ${course.ECTSCredits} ECTS - ${course.SBSCredits ? course.SBSCredits + ' SBS' : '0 SBS'}`;
                       
                        });
                    })
                    .catch(error => console.log(error));
            },

            clear() {
                this.courses = [];
                this.courseTitle = "";
            },

            addCourse({
                ID,
                CourseTitle,
                CourseCode
            }) {
                this.programCourses.push({
                    ID,
                    CourseTitle,
                    CourseCode,
                    CourseFrom: null,
                    CourseTo: null,
                    Fee: null,
                    Semester: null,
                    SemesterFrom: null,
                    SemesterTo: null,
                    ProgramYear: null,
                });

                this.clear();
            },

            removeCourse(index) {
                this.programCourses.splice(index, 1);
                this.fetchSemesters();
            },

           checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getProgramById();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },


            saveProgram() {
                this.$v.$touch();

                this.invalidProgramCode = this.program.ProgramCode == null ? true : false;
                this.invalidProgramType = this.program.ProgramType == null ? true : false;

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                this.isLoading = true;

                let formData = new FormData();

                formData.append("program", JSON.stringify(this.program));


                this.programCourses.forEach(course => formData.append("courses[]", JSON.stringify(course)));
                axios
                    .post('/api/programs', formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.message) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'ProgramIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;

                        if (error.response.data) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                    });
            },


            updateProgram() {
                this.$v.$touch();

                if (this.disableEditForm) return;

                this.invalidProgramCode = this.program.ProgramCode == null ? true : false;
                this.invalidProgramType = this.program.ProgramType == null ? true : false;

                if (this.$v.$invalid) {
                    let errorMsg = '';
                        
                    if(this.$v.program.ProgramCode.$error){
                            errorMsg = this.$t('form.program.programCode');
                      }

                      if(this.$v.program.ProgramType.$error){
                            errorMsg = errorMsg ? errorMsg +", "+this.$t('form.program.programType'): this.$t('form.program.programType');
                      }

                    if(this.$v.program.ProgramTitle.$error){
                            errorMsg = errorMsg ? errorMsg +","+ this.$t('form.program.programTitle'): this.$t('form.program.programTitle');
                      }

                    if(this.$v.program.AcademicYear.$error){
                            errorMsg = errorMsg ? errorMsg +" ,"+this.$t('form.program.academicYear'): this.$t('form.program.academicYear');
                      }

                   

                  if(this.$v.programCourses.$each.$error){
                             errorMsg = errorMsg ? errorMsg +", "+this.$t('form.program.programYear'): this.$t('form.program.programYear');
                      }


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 
                }

                this.isLoading = true;

                let courses = [];

                this.programCourses.forEach(course => {
                    course.SemesterFrom = course.Semester ? this.semesterDates['semesterFrom'][course.Semester - 1] : null;
                    course.SemesterTo = course.Semester ?  this.semesterDates['semesterTo'][course.Semester - 1] : null;
                    courses.push(JSON.stringify(course));
                    console.log(courses);
                });

                let data = {
                    program: JSON.stringify(this.program),
                    courses: courses,
                    total_fee:this.totalFee,
                }
                
                axios
                    .put("/api/programs/" + this.$route.params.id, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.message) {
                            this.showAlert(response.data.message);
                               if (this.shouldClose) {
                                    clearInterval(this.interval);
                                    setTimeout(() => this.$router.go(-1), 2000);
                                    return;
                                }
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        if (error.response) {
                            if (error.response.data.error) {
                                this.showAlert(
                                    error.response.data.message,
                                    "danger"
                                );
                            }
                        } else {
                            this.showAlert(error, "danger");
                        }
                    });
            },

            getProgramById() {
                this.isLoading = true;

                axios
                    .get("/api/programs/" + this.$route.params.id + '/edit')
                    .then(response => {

                        this.program = response.data.program;
                        this.program.BillingCycle=this.program.BillingCycle==null || this.program.BillingCycle==''?'inherit':this.program.BillingCycle;
                        this.program.GradingScaleTypeID = this.program.GradingScaleTypeID
                        ? Number(this.program.GradingScaleTypeID)
                        : null;
                       if (this.program.AcademicYear)
                            this.program.AcademicYear = moment(this.program.AcademicYear).format('YYYY');

                        if (this.program.TermFee == null)
                            this.program.TermFee = [];

                        if (this.program.ApplicationFee == null)
                            this.program.ApplicationFee = this.defaultApplicationFee;

                        this.programCourses = [];
                        response.data.courses.forEach(course => {
                            this.programCourses.push({
                                ID: course.ID,
                                CourseCode: course.CourseCode,
                                CourseTitle: course.CourseTitle,
                                CourseFrom: course.pivot.CourseFrom ? moment(course.pivot
                                        .CourseFrom)
                                    .format(this.dateFormat) : null,
                                CourseTo: course.pivot.CourseTo ? moment(course.pivot.CourseTo)
                                    .format(
                                        this.dateFormat) : null,
                                Fee: course.pivot.Fee,
                                Semester: course.pivot.Semester,
                                SemesterFrom: course.pivot.SemesterFrom ? moment(course.pivot
                                    .SemesterFrom).format(this.dateFormat) : null,
                                SemesterTo: course.pivot.SemesterTo ? moment(course.pivot
                                        .SemesterTo)
                                    .format(this.dateFormat) : null,
                                ProgramYear: course.pivot.ProgramYear,
                                InvoicedSeparately: course.pivot.InvoicedSeparately
                            });
                            this.semesterDates['semesterFrom'][course.pivot.Semester - 1] = course.pivot.Semester ? (course.pivot.SemesterFrom ? moment(course.pivot.SemesterFrom).format(this.dateFormat) : null) : null
                            this.semesterDates['semesterTo'][course.pivot.Semester - 1] = course.pivot.Semester ? (course.pivot.SemesterTo ? moment(course.pivot.SemesterTo).format(this.dateFormat) : null) : null
                        });
                        this.fetchSemesters();

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 3000);
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

            getAudits() {
                axios
                    .get(`/api/programs/${this.$route.params.id}/audits`)
                    .then(response => {
                        this.audits = response.data;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

            paginate() {
                this.getAudits();
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },
        },

        beforeRouteLeave(to, from, next) {

            clearInterval(this.interval);
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    };

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
